import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

type MetricBoxProps = React.PropsWithChildren<{
  label: string;
  current: number;
  maximum: number | null;
  buttonLabel?: string;
  onButtonClick?: () => void;
  className?: string;
}>;

const MetricBox = ({
  label,
  current,
  maximum,
  buttonLabel,
  onButtonClick,
  className,
  children,
}: MetricBoxProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col gap-2 p-4 bg-sheet border-border border-[0.5px] rounded-lg min-w-[380px]",
        className,
      )}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col gap-1">
          <span className="text-xs text-muted">{label}</span>
          <div className="flex items-baseline gap-0.5">
            <span className="text-xl font-semibold">{current}</span>
            <span className="text-sm text-placeholder">
              / {maximum ?? "unlimited"}
            </span>
          </div>
        </div>
        {buttonLabel && onButtonClick && (
          <button
            type="button"
            onClick={onButtonClick}
            className="px-3 py-1.5 bg-white border border-border text-xs font-medium rounded-md hover:bg-selectable-hover transition-colors"
          >
            {buttonLabel}
          </button>
        )}
      </div>
      {children}
    </div>
  );
};

export default MetricBox;
